"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UndrawUc = exports.UndrawTeams = exports.UndrawSharedusephone = exports.UndrawSecurity = exports.UndrawOfficeapps = exports.UndrawNetworkold = exports.UndrawNetworknew = exports.UndrawLivewebchat = exports.UndrawEmail = exports.UndrawDevices = exports.UndrawDeskphone = exports.UndrawCxds = exports.UndrawCordlessphone = exports.UndrawCloudfiles = exports.UndrawCalendar = exports.UndrawAsset = exports.UndrawAddonphone = exports.UndrawAddondevice = void 0;
var UndrawAddondevice_1 = __importDefault(require("./UndrawAddondevice"));
var UndrawAddonphone_1 = __importDefault(require("./UndrawAddonphone"));
var UndrawAsset_1 = __importDefault(require("./UndrawAsset"));
var UndrawCalendar_1 = __importDefault(require("./UndrawCalendar"));
var UndrawCloudfiles_1 = __importDefault(require("./UndrawCloudfiles"));
var UndrawCordlessphone_1 = __importDefault(require("./UndrawCordlessphone"));
var UndrawCxds_1 = __importDefault(require("./UndrawCxds"));
var UndrawDeskphone_1 = __importDefault(require("./UndrawDeskphone"));
var UndrawDevices_1 = __importDefault(require("./UndrawDevices"));
var UndrawEmail_1 = __importDefault(require("./UndrawEmail"));
var UndrawLivewebchat_1 = __importDefault(require("./UndrawLivewebchat"));
var UndrawNetworknew_1 = __importDefault(require("./UndrawNetworknew"));
var UndrawNetworkold_1 = __importDefault(require("./UndrawNetworkold"));
var UndrawOfficeapps_1 = __importDefault(require("./UndrawOfficeapps"));
var UndrawSecurity_1 = __importDefault(require("./UndrawSecurity"));
var UndrawSharedusephone_1 = __importDefault(require("./UndrawSharedusephone"));
var UndrawTeams_1 = __importDefault(require("./UndrawTeams"));
var UndrawUc_1 = __importDefault(require("./UndrawUc"));
var UndrawAddondevice_2 = require("./UndrawAddondevice");
Object.defineProperty(exports, "UndrawAddondevice", { enumerable: true, get: function () { return __importDefault(UndrawAddondevice_2).default; } });
var UndrawAddonphone_2 = require("./UndrawAddonphone");
Object.defineProperty(exports, "UndrawAddonphone", { enumerable: true, get: function () { return __importDefault(UndrawAddonphone_2).default; } });
var UndrawAsset_2 = require("./UndrawAsset");
Object.defineProperty(exports, "UndrawAsset", { enumerable: true, get: function () { return __importDefault(UndrawAsset_2).default; } });
var UndrawCalendar_2 = require("./UndrawCalendar");
Object.defineProperty(exports, "UndrawCalendar", { enumerable: true, get: function () { return __importDefault(UndrawCalendar_2).default; } });
var UndrawCloudfiles_2 = require("./UndrawCloudfiles");
Object.defineProperty(exports, "UndrawCloudfiles", { enumerable: true, get: function () { return __importDefault(UndrawCloudfiles_2).default; } });
var UndrawCordlessphone_2 = require("./UndrawCordlessphone");
Object.defineProperty(exports, "UndrawCordlessphone", { enumerable: true, get: function () { return __importDefault(UndrawCordlessphone_2).default; } });
var UndrawCxds_2 = require("./UndrawCxds");
Object.defineProperty(exports, "UndrawCxds", { enumerable: true, get: function () { return __importDefault(UndrawCxds_2).default; } });
var UndrawDeskphone_2 = require("./UndrawDeskphone");
Object.defineProperty(exports, "UndrawDeskphone", { enumerable: true, get: function () { return __importDefault(UndrawDeskphone_2).default; } });
var UndrawDevices_2 = require("./UndrawDevices");
Object.defineProperty(exports, "UndrawDevices", { enumerable: true, get: function () { return __importDefault(UndrawDevices_2).default; } });
var UndrawEmail_2 = require("./UndrawEmail");
Object.defineProperty(exports, "UndrawEmail", { enumerable: true, get: function () { return __importDefault(UndrawEmail_2).default; } });
var UndrawLivewebchat_2 = require("./UndrawLivewebchat");
Object.defineProperty(exports, "UndrawLivewebchat", { enumerable: true, get: function () { return __importDefault(UndrawLivewebchat_2).default; } });
var UndrawNetworknew_2 = require("./UndrawNetworknew");
Object.defineProperty(exports, "UndrawNetworknew", { enumerable: true, get: function () { return __importDefault(UndrawNetworknew_2).default; } });
var UndrawNetworkold_2 = require("./UndrawNetworkold");
Object.defineProperty(exports, "UndrawNetworkold", { enumerable: true, get: function () { return __importDefault(UndrawNetworkold_2).default; } });
var UndrawOfficeapps_2 = require("./UndrawOfficeapps");
Object.defineProperty(exports, "UndrawOfficeapps", { enumerable: true, get: function () { return __importDefault(UndrawOfficeapps_2).default; } });
var UndrawSecurity_2 = require("./UndrawSecurity");
Object.defineProperty(exports, "UndrawSecurity", { enumerable: true, get: function () { return __importDefault(UndrawSecurity_2).default; } });
var UndrawSharedusephone_2 = require("./UndrawSharedusephone");
Object.defineProperty(exports, "UndrawSharedusephone", { enumerable: true, get: function () { return __importDefault(UndrawSharedusephone_2).default; } });
var UndrawTeams_2 = require("./UndrawTeams");
Object.defineProperty(exports, "UndrawTeams", { enumerable: true, get: function () { return __importDefault(UndrawTeams_2).default; } });
var UndrawUc_2 = require("./UndrawUc");
Object.defineProperty(exports, "UndrawUc", { enumerable: true, get: function () { return __importDefault(UndrawUc_2).default; } });
exports.default = {
    'addondevice': UndrawAddondevice_1.default,
    'addonphone': UndrawAddonphone_1.default,
    'asset': UndrawAsset_1.default,
    'calendar': UndrawCalendar_1.default,
    'cloudfiles': UndrawCloudfiles_1.default,
    'cordlessphone': UndrawCordlessphone_1.default,
    'cxds': UndrawCxds_1.default,
    'deskphone': UndrawDeskphone_1.default,
    'devices': UndrawDevices_1.default,
    'email': UndrawEmail_1.default,
    'livewebchat': UndrawLivewebchat_1.default,
    'networknew': UndrawNetworknew_1.default,
    'networkold': UndrawNetworkold_1.default,
    'officeapps': UndrawOfficeapps_1.default,
    'security': UndrawSecurity_1.default,
    'sharedusephone': UndrawSharedusephone_1.default,
    'teams': UndrawTeams_1.default,
    'uc': UndrawUc_1.default,
};
